import React from 'react';

import { Tooltip } from 'antd';

import styles from './PublicationTargetting.module.css';

import GroupsIcon from '../../assets/img/groups.png';
import EarthIcon from '../../assets/img/earth.png';
import CityIcon from '../../assets/img/city.png';
import DistrictIcon from '../../assets/img/quartier.png';

export const PublicationTargetting: React.FC<{
  targetDistricts: Array<string>;
  targetTowns: Array<string>;
  targetDepartments?: Array<string>;
  diffusions?: any;
  isPublic?: boolean;
  publicationGroup?: boolean;
  groups?: any;
}> = ({
  targetDistricts = [],
  targetTowns = [],
  targetDepartments = [],
  diffusions,
  isPublic,
  publicationGroup,
  groups,
}) => {
  const isTarget =
    targetDistricts.length || targetTowns.length || targetDepartments.length;

  // Une diffusion qui vise un groupe prime sur la notion héritée de
  // publication « publique » : le groupe est la vraie cible.
  const space = diffusions?.[0]?.space;
  const hasGroupTarget = !!space;
  const isReseau = space?.type === 'network' && !space?.parent;

  const formatTitle = () => {
    if (isTarget === 0 && hasGroupTarget) {
      return 'Publiée dans:';
    } else if (isTarget === 0 && isPublic) {
      return 'Publiée dans la ville suivante:';
    } else if (isTarget === 0 && !isPublic && groups) {
      return 'Publiée dans le groupe suivant:';
    } else if (
      targetTowns.length > 0 &&
      targetDistricts.length === 0 &&
      targetDepartments.length === 0
    ) {
      return 'Publiée dans la ville suivante:';
    } else if (
      targetTowns.length > 0 &&
      targetDistricts.length > 0 &&
      targetDepartments.length === 0
    ) {
      return 'Publiée dans les quartiers suivants:';
    } else if (
      targetTowns.length === 0 &&
      targetDepartments.length > 0 &&
      targetDistricts.length === 0
    ) {
      return 'Publiée dans le département suivant:';
    } else if (
      targetTowns.length > 0 &&
      targetDepartments.length > 0 &&
      targetDistricts.length === 0
    ) {
      return 'Publiée dans les villes suivantes:';
    } else if (
      targetTowns.length === 0 &&
      targetDepartments.length === 0 &&
      targetDistricts.length === 0
    ) {
      return 'Publiée dans ce groupe';
    } else {
      return 'Publiée dans votre ville.';
    }
  };

  const getGroupName = () => {
    if (!diffusions) return undefined;
    // Le nom est sérialisé dans la diffusion ; le croisement avec les groupes
    // de l'utilisateur ne couvre pas les communautés dont il n'est pas membre.
    return (
      diffusions[0]?.space?.name ??
      (groups?.length > 0
        ? groups.find(
            (group: any) => group?.target.id === diffusions[0]?.space.id
          )?.target.name
        : undefined)
    );
  };

  const computeTarget = () => {
    if (isTarget === 0 && hasGroupTarget)
      return (
        <span className={styles.target}>
          {isReseau ? 'le Réseau' : 'la Communauté'} {getGroupName()}
        </span>
      );

    if (isTarget === 0 && isPublic)
      return (
        <span className={styles.target}>
          {diffusions && diffusions[0]?.place?.address?.locality}
        </span>
      );

    if (isTarget === 0 && !isPublic)
      return <span className={styles.target}>{getGroupName()}</span>;

    if (targetTowns.length > 0 && targetDistricts.length === 0)
      return targetTowns.map((town, index) => (
        <span key={`${index}-town`} className={styles.target}>
          {town}
        </span>
      ));

    if (targetTowns.length > 0 && targetDistricts.length > 0)
      return targetDistricts.map((district, index) => (
        <span key={`${index}-district`} className={styles.target}>
          {district}
        </span>
      ));

    if (targetTowns.length === 0 && targetDepartments.length > 0)
      return targetDepartments.map((department, index) => (
        <span key={`${index}-department`} className={styles.target}>
          {department}
        </span>
      ));

    if (targetTowns.length > 0 && targetDepartments.length > 0)
      return targetTowns.map((town, index) => (
        <span key={`${index}-city`} className={styles.target}>
          {town}
        </span>
      ));
  };

  return (
    <Tooltip
      placement="right"
      color="#fff"
      overlayClassName={styles.tooltip}
      title={
        <>
          <div className={styles.containerTooltip}>
            <p className={styles.containerTitle}>{formatTitle()}</p>
            {!publicationGroup && (
              <div className={styles.containerTarget}>{computeTarget()}</div>
            )}
          </div>
        </>
      }
    >
      {isTarget === 0 && (hasGroupTarget || !isPublic) ? (
        <img className={styles.targetIcon} src={GroupsIcon} alt="groups" />
      ) : targetDepartments.length && !targetTowns.length ? (
        <img className={styles.targetIcon} src={EarthIcon} alt="earth" />
      ) : targetDistricts.length && targetTowns.length ? (
        <img className={styles.targetIcon} src={DistrictIcon} alt="district" />
      ) : (
        <img className={styles.targetIcon} src={CityIcon} alt="city" />
      )}
    </Tooltip>
  );
};
